import React from "react";
import { Route } from "react-router-dom";
export const RouteWithLayout = (props) => {
  const { layout: Layout, component: Component, ...rest } = props;
  return (
    <Route {...rest} render={matchProps => {
      if(Layout){
        return (
          <Layout {...matchProps}>
            <Component {...matchProps} />
          </Layout>
        )
      }else{
        return (
          <Component {...matchProps} />
        )
      }

    }}
  />)
};
  // return (<Route {...rest} render={matchProps => (
  //       <Component {...matchProps}/>
  //       )}/>)

